import { Stack } from '@mui/material';
import { Banner } from '@/components/shared/Banner';
import { UploadPanel, EsSheetData } from '../shared/UploadPanel/UploadPanel';
import { useSetAtom } from 'jotai';

import { useWizard } from '../context';
import { ES_MAPPING_KEYS } from '@/components/EsSheet/data';
import * as state from '@/components/Analysis/state';
import { getNextValidStep } from '../shared/validation';

export const LegacyData: React.FC = () => {
  const { goToStep } = useWizard();
  const setOriginalEsSheet = useSetAtom(state.originalEsSheet);
  const setEditableEsSheet = useSetAtom(state.editableEsSheet);

  const handleFileParsed = (data: EsSheetData) => {
    setOriginalEsSheet(null);
    setEditableEsSheet(null);
    // Store original copy
    setOriginalEsSheet(data);

    // Create initial column mappings based on header names
    const initialMappings: Record<string, string> = {};
    data.headers.forEach((header) => {
      const matchingTarget = ES_MAPPING_KEYS.find(
        (target) => target.name.toLowerCase() === header.toLowerCase()
      );
      if (matchingTarget) {
        initialMappings[header] = matchingTarget.key;
      }
    });

    // Store editable copy with initial mappings
    const editableData = {
      ...data,
      mappings: initialMappings,
    };
    setEditableEsSheet(editableData);

    // Smart navigation: skip to the first step that needs attention
    const nextStep = getNextValidStep(editableData);
    goToStep(nextStep);
  };

  return (
    <Stack gap="2.4rem" paddingTop="2.4rem" height="100%">
      <Banner message="Use this to upload legacy data into Abyss Fabric." severity="info" />
      <UploadPanel
        onFileParsed={handleFileParsed}
        templateFilePath="/assets/es-sheet-template/legacy-es-sheet-template.xlsx"
      />
    </Stack>
  );
};
